import { createSelector } from 'reselect';

const selectProductionUnits = (state: any) => state.productionUnits;


export const selectProductionUnitsCurrentItem = createSelector([selectProductionUnits], (productionUnits) => productionUnits.current);

export const selectProductionUnitsListItems = createSelector([selectProductionUnits], (productionUnits) => productionUnits.list);

export const selectProductionUnitsItemById = (itemId: any) =>
    createSelector(selectProductionUnitsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductionUnitsQueryItems = createSelector([selectProductionUnits], (productionUnits) => productionUnits.query);

export const selectProductionUnitsCreatedItem = createSelector([selectProductionUnits], (productionUnits) => productionUnits.create);

export const selectProductionUnitsUpdatedItem = createSelector([selectProductionUnits], (productionUnits) => productionUnits.update);

export const selectProductionUnitsReadItem = createSelector([selectProductionUnits], (productionUnits) => productionUnits.read);

export const selectProductionUnitsDeletedItem = createSelector([selectProductionUnits], (productionUnits) => productionUnits.delete);

export const selectProductionUnitsSearchedItems = createSelector([selectProductionUnits], (productionUnits) => productionUnits.search);

export const selectProductionUnitsItemsCount = createSelector([selectProductionUnits], (productionUnits) => productionUnits.count);

export const selectProductionUnitsItemsFilter = createSelector([selectProductionUnits], (productionUnits) => productionUnits.filter);